import { useQuery } from 'react-query';
import FloorPlanService from '../../services/floorPlanService';

const floorPlanService = new FloorPlanService();

// Shares its query key with ManageAffordableWaitlistV2/hooks.useBedroomSizes.js
// and SelectFromWaitlist/SelectFromWaitlistModal/hooks.queries.js, so callers
// usually read the cache rather than issuing a request.
const useFloorPlansQuery = ({ organizationId, propertyId, enabled = true }) =>
  useQuery(
    ['floorPlans', organizationId, propertyId],
    () => floorPlanService.getAll(organizationId, propertyId, {}),
    {
      enabled: Boolean(organizationId && propertyId) && enabled,
      select: (data) => data || [],
    },
  );

export default useFloorPlansQuery;
